<ng-select
  [items]="displayedEvents"
  bindLabel="name"
  bindValue="id"
  [(ngModel)]="selectedEventId"
  (change)="onSelectionChange($event)"
  [clearable]="false"
  [disabled]="disabled"
  [placeholder]="placeholder | translate"
  [notFoundText]="'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate"
  appendTo="body"
  class="ticketselectbox">
  <ng-template ng-label-tmp let-value="value" let-clear="clear">
    <span class="ng-value-label">{{ formatEventDisplay(getSelectedEventItem()) }}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    {{ formatEventDisplay(item) }}
  </ng-template>
</ng-select>
